import { env } from '@/env';

export const UTM_PARAMS = Object.freeze({
  utm_campaign: 'utmCampaign',
  utm_content: 'utmContent',
  utm_medium: 'utmMedium',
  utm_source: 'utmSource',
  utm_term: 'utmTerm',
});

type UTMParam = (typeof UTM_PARAMS)[keyof typeof UTM_PARAMS];

export type UTMParams = {
  [key in UTMParam]?: string;
};

const saveUTMParams: () => UTMParams | null = () => {
  try {
    const params = window?.location?.search;
    if (params) {
      const urlParams = Object.fromEntries(new URLSearchParams(params));
      const urlParamsLowerCased = Object.fromEntries(
        Object.entries(urlParams).map(([key, value]) => [key.toLowerCase(), value]),
      );
      const UTM_PARAMS_KEYS = Object.keys(UTM_PARAMS) as Array<keyof typeof UTM_PARAMS>;
      const isUTMParamExist = UTM_PARAMS_KEYS.some(param => !!urlParamsLowerCased[param]);
      if (isUTMParamExist) {
        const paramsToSave = Object.assign(
          {},
          ...UTM_PARAMS_KEYS.map(
            param =>
              urlParamsLowerCased[param] && {
                [UTM_PARAMS[param]]: urlParamsLowerCased[param],
              },
          ),
        );
        localStorage.setItem('utmParams', JSON.stringify(paramsToSave));
        return paramsToSave;
      }
    }
  } catch (e) {
    if (!env.IS_PROD) {
      console.error(e);
    } else {
      console.warn('UTM Warning');
    }
  }
  return null;
};

export { saveUTMParams };
